var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DynamicState"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.data.content))]),_c('div',{staticClass:"box"},_vm._l((_vm.imageUrlsList),function(item,index){return _c('el-image',{key:index,staticStyle:{"width":"200px","height":"200px"},attrs:{"fit":"cover","src":item,"preview-src-list":_vm.imageUrlsList}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }